import React from "react";
import { useNavigate } from "react-router-dom"; 
import heroImg from "../../assets/hero1.png";
import logo from "../../assets/icon.png"; 

const styles = {
  section: {
    position: "relative",
    minHeight: "100vh",
    width: "100%",
    margin: 0,
    padding: 0,
    display: "flex",
    alignItems: "center",
    color: "white",
    overflow: "hidden",
  },
  backgroundImage: {
    position: "absolute",
    top: "0",
    left: "0",
    width: "100%",
    height: "100%",
    objectFit: "cover",
    zIndex: "-10",
  },
  overlay: {
    position: "absolute",
    inset: "0",
    backgroundColor: "rgba(0,0,0,0.4)",
    zIndex: "-10",
  },
  content: {
    textAlign: "left",
    padding: "2rem",
    maxWidth: "700px",
  },
  heading: {
    fontSize: "clamp(1.8rem, 5vw, 3rem)", 
    fontWeight: "800",
    lineHeight: "1.4",
    margin: "0",
    fontFamily: "'Poppins', sans-serif",
    textShadow: "2px 2px 4px rgba(0, 0, 0, 0.7)",
    letterSpacing: "0.05em",
    wordSpacing: "0.25em",
  },
  highlight: {
    color: "#f97316",
  },
  subText: {
    fontSize: "clamp(0.9rem, 2.5vw, 1.2rem)",
    fontFamily: "'Poppins', sans-serif",
    marginTop: "1rem",
    marginBottom: "1.5rem",
    lineHeight: "1.5",
    maxWidth: "600px",
    textShadow: "1px 1px 3px rgba(0, 0, 0, 0.5)",
  },
  button: {
    marginTop: "2rem",
    padding: "0.9rem 1.5rem",
    backgroundColor: "#f97316",
    borderRadius: "5rem",
    fontWeight: "600",
    cursor: "pointer",
    border: "none",
    fontSize: "1rem",
    color: "#fff",
    transition: "background 0.3s ease",
  },
  logoMobile: {
    display: "none", 
    width: "12rem",
    marginTop: "-3rem",
  },
};

export default function Hero() {
  const navigate = useNavigate();

  return (
    <section id="home" style={styles.section}>
      <img src={heroImg} alt="Tiffin" style={styles.backgroundImage} />
      <div style={styles.overlay} />

      <div style={styles.content}>
        {/* Mobile-only logo */}
        <img src={logo} alt="TIFFO Logo" className="logo-mobile" style={styles.logoMobile} />

        <h1 style={styles.heading}>
          <span>Freshly Cooked.</span> <br />
          <span style={styles.highlight}>Lovingly Packed.</span> <br />
          Delivered Daily.
        </h1>
        <p style={styles.subText}>
          Experience the authentic taste of home-cooked meals delivered right to
          your doorstep in Oshawa. Healthy, delicious, and made with love.
        </p>

        <button
          style={styles.button}
          onMouseEnter={(e) => (e.target.style.backgroundColor = "#ea580c")}
          onMouseLeave={(e) => (e.target.style.backgroundColor = "#f97316")}
          onClick={() => navigate("/menu")} 
        >
          Check Out Our Weekly Menu
        </button>
      </div>

      <style>
        {`
          @media (max-width: 768px) {
            .logo-mobile {
              display: block !important;
              margin: 0 auto 1rem auto;
              margin-bottom: 5rem;
              width: 10rem;
            }
          }
        `}
      </style>
    </section>
  );
}
